<template>
  <div class="service-page max-width">
    <div class="left">
      <div class="box add-card newbox" @click="gotoAdd">
        <div class="box-title" style="color: #ffffff">点击发布诉求</div>
        <img :src="require('@/assets/images/发布诉求.png')" alt="" />
      </div>
      <div class="box mine-card">
        <div class="box-title">我的诉求</div>
        <div class="mine-item" @click="gotoMyService(0)">
          <img :src="require('@/assets/images/已处理.png')" alt="" />
          <div class="mine-type">已处理</div>
          <div class="mine-num">{{ countInfo.processed }}</div>
        </div>
        <div class="mine-item" @click="gotoMyService(0)">
          <img :src="require('@/assets/images/未处理.png')" alt="" />
          <div class="mine-type">未处理</div>
          <div class="mine-num">{{ countInfo.unProcess }}</div>
        </div>
      </div>
      <div class="box phone-card">
        <div style="font-size: 1.25vw; color: #333333; letter-spacing: 0; font-weight: 600">服务热线：</div>
        <div class="phonenum" style="margin-top: 30px">0574-87183315</div>
        <div class="phonenum" style="margin-top: 12px">0574-81890910</div>
      </div>
    </div>
    <div class="right box">
      <div class="search-header">
        <div class="box-title">常见诉求</div>
        <el-input v-model="dataForm.quesDes__quesContent" clearable style="width: 400px" placeholder="请输入">
          <el-button slot="append" icon="el-icon-search" type="primary" @click="getServiceList">查询</el-button>
        </el-input>
      </div>
      <div class="filter-item">
        诉求类型：<span
          v-for="item in serviceTypeList"
          :key="item.cd"
          class="item-type"
          :class="[dataForm.quesType === item.cd ? 'active' : '']"
          @click="selectType(item.cd)"
          >{{ item.nm }}</span
        >
      </div>
      <div v-if="list.length">
        <div v-for="item in list" :key="item.id" class="ans-box">
          <div class="ans-box-item">
            <div class="ans-box-title"><img :src="require('@/assets/images/问.png')" alt="" />{{ item.quesDes }}</div>
            <div class="ans-box-time">{{ item.quesTime }}</div>
          </div>
          <div class="ans-box-content">
            <img :src="require('@/assets/images/答.png')" alt="" />
            <expendBox :text="item.quesContent" />
          </div>
        </div>
        <el-pagination
          layout="prev, pager, next"
          :current-page="page.pageNo"
          :page-size="page.pageSize"
          :background="true"
          :total="total"
          @current-change="currentChangeHandle"
        />
      </div>
      <div v-else class="no-msg">暂无数据</div>
    </div>
  </div>
</template>

<script>
import expendBox from '@/components/expendBox'
import { checkLogin } from '@/utils/checkLogin'
export default {
  components: {
    expendBox,
  },
  data() {
    return {
      total: 0,
      countInfo: {
        processed: '-',
        unProcess: '-',
      },
      page: {
        pageNo: 1,
        pageSize: 5,
      },
      dataForm: {
        quesType: '',
      },
      serviceTypeList: [],
      list: [],
    }
  },
  mounted() {
    this.getServiceList()
    this.getServiceSelf()
    this.getEnum('ZzmhComQuesEn$QuesType', 'serviceTypeList')
  },
  methods: {
    gotoMyService(type) {
      if (checkLogin()) {
        this.$router.push({
          path: '/user/myService',
        })
      }
    },
    gotoAdd() {
      if (checkLogin()) {
        this.$router.push({
          path: '/service/add',
        })
      }
    },
    getEnum(code, key) {
      this.$http({ method: 'get', url: `/general/enum/list?cls=${code}` }).then((res) => {
        this[key] = [{ nm: '全部', cd: '' }, ...res.data.list]
      })
    },
    handleSizeChange(val) {
      this.page.pageNo = 1
      this.page.pageSize = val
      this.getServiceList()
    },
    currentChangeHandle(val) {
      this.page.pageNo = val
      this.getServiceList()
    },
    selectType(type) {
      this.dataForm.quesType = type
      this.getServiceList()
    },
    getServiceSelf() {
      this.$http({ method: 'get', url: '/zzmh/in/personQues/countNum' }).then((res) => {
        this.countInfo = res.data
      })
    },
    getServiceList() {
      let query = this.$query.new()
      this.$query.toF(query, this.dataForm)
      this.$query.toP(query, this.page.pageNo, this.page.pageSize)
      let params = {}
      this.$http({ method: 'get', url: '/zzmh/api/comQues/page?query=' + encodeURIComponent(this.$query.toJsonStr(query)), params }).then((res) => {
        console.log(res)
        this.list = res.data.list
        this.total = res.page.total
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
